import { createRegisterCleaner } from '../../watchers/createRegisterCleaner';
import { useSale } from './useSale';

export const useSaleRegisterCleaner = createRegisterCleaner({
  useStoreHook: useSale,
  targetPathPrefix: '/sale-register',
  resetFnName: 'handlerResetSaleForm', // limpia el formulario al salir (sin marcar correlativo)
});
